import { select, selectAll } from 'helpers/dom'

const selectors = {
  ITEM_SELECTOR: '.js-accordion-item',
  BUTTON_SELECTOR: '.js-accordion-button',
  CONTENT_SELECTOR: '.js-accordion-content',
  HEADING_BUTTON_CLASS: '.js-accordion-button .text',
  VIDEO_PLAYER_SELECTOR: 'video-player',
  READ_MORE_ACCORDION_SELECTOR: 'read-more-accordion'
}

class AccordionList extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  close(items) {
    items.forEach((item) => {
      const content = select(selectors.CONTENT_SELECTOR, item)
      const button = select(selectors.BUTTON_SELECTOR)
      const videoEls = selectAll(selectors.VIDEO_PLAYER_SELECTOR, item)
      const readMoreAccordion = select(selectors.READ_MORE_ACCORDION_SELECTOR, item)

      if (button && content) {
        content.style.maxHeight = '0px'
        button.setAttribute('aria-expanded', 'false')
        item.removeAttribute('open')
      }

      if (videoEls.length > 0) {
        videoEls.forEach((video) => video.pause())
      }

      if (readMoreAccordion) {
        readMoreAccordion.setCollapsedState()
      }
    })
  }

  open(item) {
    const content = item.querySelector(selectors.CONTENT_SELECTOR)
    const button = item.querySelector(selectors.BUTTON_SELECTOR)

    content.style.maxHeight = content.children[0].scrollHeight + 'px'
    button.setAttribute('aria-expanded', 'true')
    item.setAttribute('open', true)
  }

  toggleDescription(item, list) {
    if (item && !item.hasAttribute('open')) {
      this.open(item)
    } else {
      this.close([item])
    }
  }

  init() {
    const list = this.querySelectorAll(selectors.ITEM_SELECTOR)

    if (list.length) {
      list.forEach((item) => {
        const button = item.querySelector(selectors.BUTTON_SELECTOR)

        if (item.hasAttribute('open')) {
          this.open(item)
        }

        if (button) {
          const _this = this

          button.onclick = function (e) {
            if (location.pathname.includes('store-locator')) {
              e.stopPropagation()
            }
            _this.toggleDescription(item, list)
          }
        }
      })
    }
  }
}

if (!customElements.get('accordion-list')) {
  customElements.define('accordion-list', AccordionList)
}
